<template>
  <div>
    <h1 class="mb-30">Справочник</h1>

    <ul class="card-list">
      <li
        v-for="(item, index) in handbookList"
        :key="index"
        class="card-list__item"
      >
        <router-link
          class="card-list__link"
          :to="{ name: 'HandbookUpdate', params: { handbookName: item.name } }"
        >
          {{ item.pageTitle }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { HANDBOOK_LIST } from '@/const/handbookList'

export default {
  computed: {
    handbookList () {
      return Object.values(HANDBOOK_LIST)
    }
  }
}
</script>
